// @flow @jsx h
import { h, Component } from 'preact'

type ErrorReport = {
  message: string
}

type ProviderProps = {
  sendErrorReport: (e: ErrorReport) => void,
  trackAction: (e: string) => void
}

class Provider extends Component<ProviderProps & { children: Array<any> }, {}> {
  getChildContext () {
    return {
      sendErrorReport: this.props.sendErrorReport,
      trackAction: this.props.trackAction
    }
  }
  render () {
    return this.props.children[0]
  }
}

Provider.displayName = 'Provider'

type MapStateToProps = (...Array<any>) => Object

function connect (mapStateToProps?: MapStateToProps) {
  return (wrappedComponent: any) => {
    class Connected extends Component<{}, {}> {
      mapStateToProps = (opts: ProviderProps): Object => {
        return mapStateToProps ? mapStateToProps(opts) : opts
      }
      render () {
        return h(wrappedComponent, {
          ...this.mapStateToProps({
            sendErrorReport: this.context.sendErrorReport,
            trackAction: this.context.trackAction
          }),
          ...this.props
        })
      }
    }
    Connected.displayName = `connect(${wrappedComponent.displayName || wrappedComponent.name || 'Component'})`
    return Connected
  }
}

export { Provider, connect }



// WEBPACK FOOTER //
// ./src/lib/provider.js